var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-inner"},[_c('figure',[_c('div',{staticClass:"video-container",domProps:{"innerHTML":_vm._s(_vm.block.embed.video)}}),_vm._v(" "),(_vm.block.embed.caption)?_c('figcaption',{staticClass:"pt-4"},[_vm._v(_vm._s(_vm.block.embed.caption))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }